import Game from "../Game";
import GameCore from "../GameCore";
import BaseBullet from "./BaseBullet";
import BaseWeapon from "./BaseWeapon";
import { BulletGroup } from "./BulletGroup";
import {
  SPRITESHEET_KEYS,
  SPRITESHEET_FRAMES,
} from "../../consts/SPRITESHEETS";

export default class BubbleBullet extends BaseBullet {
  radius: number;
  ExpireTimer: Phaser.Time.TimerEvent;
  constructor(
    group: BulletGroup,
    weapon: BaseWeapon,
    indexInWeapon = 0,
    x: number = 0,
    y: number = 0
  ) {
    super(group, weapon, indexInWeapon, "", x, y, SPRITESHEET_KEYS.WEAPONS);
    this.setTexture(
      SPRITESHEET_KEYS.WEAPONS,
      SPRITESHEET_FRAMES.WEAPONS.BUBBLE
    );
    this.radius = 16;
    this.copyPosition(Game.Core.Player);
  }
  OnRecycle(): void {
    super.OnRecycle();
    this.setTexture(
      SPRITESHEET_KEYS.WEAPONS,
      SPRITESHEET_FRAMES.WEAPONS.BUBBLE
    );
    if (this.body) {
      this.body.setCircle(this.radius);
    }
    this.setScale(3 * GameCore.PixelScale * this.weapon.PArea);
    this.setVisible(false);
    Game.Core.scene.time.removeEvent(this.ExpireTimer);
    this.ExpireTimer = Game.Core.scene.time.addEvent({
      delay: this.weapon.PInterval,
      loop: false,
      callback: () => {
        Game.Core.scene.time.removeEvent(this.ExpireTimer);
        this.DeSpawn();
      },
    });
  }
  Update() {
    this.copyPosition(Game.Core.Player);
  }
}
